import React, { useEffect } from 'react';
import SignaturePage from '../../components/signature-page';
import TnCPage from '../../components/tnc-page';
import useState from 'react-usestateref';

export default function TNCDeclarationHome() {
	const [__, setCurrentStep, currentStepRef] = useState('TnC');

	if (currentStepRef?.current === 'TnC')
		return <TnCPage setCurrentStep={setCurrentStep} />;
	else return <SignaturePage setCurrentStep={setCurrentStep} />;
}
